export interface ISuvoProcurementCategoryHierarchyNode {
  /** Name of the category. */
  name: string;

  /** The two-digit code part for this level. */
  value: string;

  /** Category children. `undefined` for leaf nodes. */
  items?: ISuvoProcurementCategoryHierarchyNode[];
}

export const suvoProcurementCategoryPrefixRegex = /^(?:\d{2})(?:-\d{2}){0,7}$/;

export const RAIL = '01';

export const suvoProcurementCategoryHierarchy: ISuvoProcurementCategoryHierarchyNode[] = [
  {
    name: 'Rail Industry',
    value: RAIL,
    items: [
      {
        name: 'Track',
        value: '01',
        items: [
          {
            name: 'Rails and fastenings',
            value: '01',
          },
          {
            name: 'Points, turnouts, switches, and crossings',
            value: '02',
          },
          {
            name: 'Sleepers/Ties',
            value: '03',
          },
          {
            name: 'Ballastless track',
            value: '04',
          },
          {
            name: 'Track construction materials',
            value: '05',
          },
          {
            name: 'Points heating system',
            value: '06',
          },
          {
            name: 'Track maintenance equipment (includes lining, levelling, and tamping machines; ballast regulators and cleaners)',
            value: '07',
          },
          {
            name: 'Track renewal/laying machines and systems',
            value: '08',
          },
          {
            name: 'Track-recording cars and measuring systems',
            value: '09',
          },
          {
            name: 'Railway construction works',
            value: '10',
          },
          {
            name: 'Construction work for buildings relating to railway transport',
            value: '11',
          },
          {
            name: 'Railway-track maintenance services',
            value: '12',
          },
          {
            name: 'Railway-track inspection services',
            value: '13',
          },
          {
            name: 'Railway engineering & consultancy services',
            value: '14',
          },
        ],
      },
      {
        name: 'Rolling stock',
        value: '02',
        items: [
          {
            name: 'Passenger cars/coaches',
            value: '01',
          },
          {
            name: 'Trams and Light Rail Vehicles (LRVs)',
            value: '02',
          },
          {
            name: 'Freight cars/wagons',
            value: '03',
          },
          {
            name: 'Brakes and braking systems',
            value: '04',
          },
          {
            name: 'Suspension systems',
            value: '05',
          },
          {
            name: 'Wheels, axles and wheelsets',
            value: '06',
          },
          {
            name: 'Seats and upholstery',
            value: '07',
          },
          {
            name: 'Doors, door control systems, and actuators',
            value: '08',
          },
          {
            name: 'Couplers and drawgear',
            value: '09',
          },
          {
            name: 'Air-conditioning, heating and ventilation',
            value: '10',
          },
          {
            name: 'Train lighting',
            value: '11',
          },
          {
            name: 'Train toilets and waste management systems',
            value: '12',
          },
          {
            name: 'Inter-car gangways',
            value: '13',
          },
          {
            name: 'Train windows',
            value: '14',
          },
          {
            name: 'Interior panels, flooring and fittings',
            value: '15',
          },
          {
            name: 'Repair and maintenance services of rolling stock',
            value: '16',
          },
        ],
      },
      {
        name: 'Locomotives',
        value: '03',
        items: [
          {
            name: 'Diesel locomotives',
            value: '01',
          },
          {
            name: 'Electric locomotives',
            value: '02',
          },
          {
            name: 'Diesel engines',
            value: '03',
          },
          {
            name: 'Electric traction and control systems',
            value: '04',
          },
          {
            name: 'Hydraulic transmission/drive and control systems',
            value: '05',
          },
          {
            name: 'Train auxiliary equipment and systems',
            value: '06',
          },
          {
            name: 'Locomotive/train cab equipment',
            value: '07',
          },
          {
            name: 'Repair and maintenance services of locomotives',
            value: '08',
          },
        ],
      },
      {
        name: 'Signalling, Communications and IT',
        value: '04',
        items: [
          {
            name: 'ERTMS, ETCS and GSM-R systems and equipment',
            value: '01',
          },
          {
            name: 'CBTC systems',
            value: '02',
          },
          {
            name: 'Signalling cables',
            value: '03',
          },
          {
            name: 'Train-monitoring system',
            value: '04',
          },
          {
            name: 'Train Management System',
            value: '05',
          },
          {
            name: 'Control equipment',
            value: '06',
          },
          {
            name: 'Railway SCADA systems',
            value: '07',
          },
          {
            name: 'Level/grade crossing systems and equipment',
            value: '08',
          },
          {
            name: 'Telecommunications and IT',
            value: '09',
          },
        ],
      },
      {
        name: 'Other',
        value: '99',
        items: [
          {
            name: 'Electrical installations for railways',
            value: '01',
          },
          {
            name: 'Traction power supply systems',
            value: '02',
          },
          {
            name: 'Train simulators',
            value: '03',
          },
          {
            name: 'Parts for railway or tramway locomotives or rolling stock',
            value: '04',
          },
          {
            name: 'Freight Rail',
            value: '05',
          },
          {
            name: 'Passenger Rail',
            value: '06',
          },
          {
            name: 'Public transport services by tram',
            value: '07',
          },
          {
            name: 'Passenger information and entertainment systems, public address and CCTV',
            value: '08',
          },
          {
            name: 'Fare collection equipment',
            value: '09',
          },
          {
            name: 'Platform screen doors',
            value: '10',
          },
          {
            name: 'Support services for railway transport',
            value: '11',
          },
          {
            name: 'Technical services for Rail locomotive and rolling stock design',
            value: '12',
          },
          {
            name: 'Train/depot maintenance services and equipment',
            value: '13',
          },
          {
            name: 'Operations & Maintenance',
            value: '14',
          },
          {
            name: 'Hire/leasing of railway vehicles',
            value: '15',
          },
          {
            name: 'Hire/leasing of trains',
            value: '16',
          },
          {
            name: 'Hire/leasing of locomotives',
            value: '17',
          },
          {
            name: 'Other',
            value: '99',
          },
        ],
      },
    ],
  },
  {
    name: 'Other Industries',
    value: '99',
  },
];
